export default __webpack_public_path__ + "static/media/ficsmas_bow.1cc83880.png";